const ActionTypes = {
  FETCH_LOGIN_USER_PROFILE_FROM_SESSION_REQUEST:
    'loginUserProfile/fetchUserProfileFromSessionRequest',
  FETCH_LOGIN_USER_PROFILE_REQUEST: 'loginUserProfile/fetchUserProfileRequest',
  FETCH_LOGIN_USER_PROFILE_SUCCESS: 'loginUserProfile/fetchUserProfileSuccess',
  FETCH_LOGIN_USER_PROFILE_FAILURE: 'loginUserProfile/fetchUserProfileFailure',
  LOGOUT_USER_PROFILE_REQUEST: 'loginUserProfile/logoutUserProfileRequest',
  LOGOUT_USER_PROFILE_SUCCESS: 'loginUserProfile/logoutUserProfileSuccess',
  LOGOUT_USER_PROFILE_FAILURE: 'loginUserProfile/logoutUserProfileFailure',
  UPDATE_USER_PROFILE_REQUEST: 'loginUserProfile/updateUserProfileRequest',
  UPDATE_USER_PROFILE_SUCCESS: 'loginUserProfile/updateUserProfileSuccess',
  UPDATE_USER_PROFILE_FAILURE: 'loginUserProfile/updateUserProfileFailure',
};

export const fetchLoginUserProfileFromSessionRequest = () => ({
  type: ActionTypes.FETCH_LOGIN_USER_PROFILE_FROM_SESSION_REQUEST,
});

export const fetchLoginUserProfileRequest = (payload: any) => ({
  type: ActionTypes.FETCH_LOGIN_USER_PROFILE_REQUEST,
  payload,
});

export const fetchLoginUserProfileSuccess = (payload: any) => ({
  type: ActionTypes.FETCH_LOGIN_USER_PROFILE_SUCCESS,
  payload,
});

export const fetchLoginUserProfileFailure = (error: string) => ({
  type: ActionTypes.FETCH_LOGIN_USER_PROFILE_FAILURE,
  payload: error,
});

export const logoutUserProfileRequest = () => ({
  type: ActionTypes.LOGOUT_USER_PROFILE_REQUEST,
});

export const logoutUserProfileSuccess = () => ({
  type: ActionTypes.LOGOUT_USER_PROFILE_SUCCESS,
});

export const logoutUserProfileFailure = (error: string) => ({
  type: ActionTypes.LOGOUT_USER_PROFILE_FAILURE,
  payload: error,
});

export const updateUserProfileRequest = (payload: any) => ({
  type: ActionTypes.UPDATE_USER_PROFILE_REQUEST,
  payload,
});

export const updateUserProfileSuccess = (payload: any) => ({
  type: ActionTypes.UPDATE_USER_PROFILE_SUCCESS,
  payload,
});

export const updateUserProfileFailure = (error: string) => ({
  type: ActionTypes.UPDATE_USER_PROFILE_FAILURE,
  payload: error,
});

export default ActionTypes;